import * as React from 'react';
import type { VoucherJustification as Justification } from 'contracts/delivery-vouchers/delivery-voucher-justifications';
import { api, applyQueryString } from 'services/api';
import { multiSelectorOptionsMapper, optionsMapper } from '../utils';
import { useQuery } from 'react-query';

export const useDeliveryVoucherJustificationOptions = () => {
  const fetchOptions = React.useCallback(async () => {
    const url = applyQueryString('/delivery-voucher-justifications', {
      asList: true,
    });

    const { data } = await api.get<Justification[]>(url);
    return data.map(({ id, justification }) => ({
      value: id,
      label: justification,
    }));
  }, []);

  const optionsQuery = useQuery({
    queryKey: ['fetch-voucher-justification-options'],
    queryFn: fetchOptions,
    initialData: [],
    refetchOnWindowFocus: false,
  });

  return {
    singleSelectOptions: optionsQuery.data?.map(optionsMapper) || [],
    multiSelectOptions:
      optionsQuery.data?.map(multiSelectorOptionsMapper) || [],
    loading: optionsQuery.isLoading,
  };
};
